/*
 * @Author: luyaj 1579618152@qq.com
 * @Date: 2025-03-13 19:52:31
 * @LastEditors: luyaj 1579618152@qq.com
 * @LastEditTime: 2025-04-19 18:46:52
 * @FilePath: \my-vue-project\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import './assets/css/fonts.css';
import './assets/css/responsive.less';
import { applyPageSeo } from './seo';
import { PATH_SEO, STATIC_PAGE_SEO } from './seo/config';
import { canonicalPath } from './seo/text';
import { notifyRenderReady, resetRenderReady } from './seo/render';
import { recordPageView } from './utils/visitTracker';

const app = createApp(App)
app.use(router)

let renderFallbackTimer

router.beforeEach(() => {
  resetRenderReady()
})

router.afterEach((to) => {
  const seo = STATIC_PAGE_SEO[to.name] || PATH_SEO[to.path]
  if (seo) {
    applyPageSeo({
      title: seo.title,
      description: seo.description,
      path: canonicalPath(to.path),
      image: seo.image,
    })
  }

  recordPageView(to.path)

  clearTimeout(renderFallbackTimer)
  renderFallbackTimer = setTimeout(() => notifyRenderReady(), 8000)
})

router.isReady().then(() => {
  app.mount('#app')
})
